<script lang="ts">import Link from '../Link/Link.svelte';
const { id = '', title = '', excludeTitleOnDesktop = false, navItems = [], linkStartingIndex = 0, slideInFrom = 'top', } = $props();
</script>

<div class="LinkList" data-entry-id={id}>
  {#if !excludeTitleOnDesktop}
    <span class="title slide-in-from-{slideInFrom}" style:--link-list-item-number={linkStartingIndex + 1}>
      {title}
    </span>
  {/if}
  <ul class="link-list">
    {#each navItems as item, index}
      <li
        class="slide-in-from-{slideInFrom}"
        style:--link-list-item-number={linkStartingIndex + index + (excludeTitleOnDesktop ? 1 : 2)}
      >
        <Link
          linkCustomCssClass="link-list-link"
          id={item.contentfulEntryId}
          title={item.props.title}
          url={item.props.url}
          icon={item.props.icon}
          linkStyle={item.props.linkStyle}
          enableHoverOpacity={true}
          openInNewTab={item.props.openInNewTab}
        />
      </li>
    {/each}
  </ul>
</div>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.LinkList {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.LinkList .title {
  --letter-spacing: var(--text-variant-50-letter-spacing);
  --line-height: var(--text-variant-50-line-height);
  --font-size: var(--text-variant-50-font-size);
  --font-weight: var(--text-variant-50-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-50-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  display: block;
  width: max-content;
  color: var(--color-neutral-400);
}
.LinkList .link-list {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.LinkList .link-list > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.LinkList .link-list > li::before {
  display: none;
}
.LinkList .link-list > li :global(:last-child) {
  margin: 0;
}</style>
